export default __webpack_public_path__ + "static/media/home_care_intro_1.563bfc66.png";